import { useEffect, useState } from 'react';

import { IMenuTileItemOption } from 'components/menu-tile-grid/types';
import { useFeatureDepositPriceExclusionQuery } from 'generated/sanity-graphql';
import { useStoreContext } from 'state/store';
import { useStoreUtils } from 'state/store/hooks/use-store-utils';

export const useExcludedDepositValue = (itemOptions: IMenuTileItemOption): number => {
  const { store } = useStoreContext();

  const { prices } = useStoreUtils({
    resetStore: () => {},
    store,
  });
  const [depositValue, setDepositValue] = useState<number>(0);

  const { data: depositExclusionData } = useFeatureDepositPriceExclusionQuery({
    variables: { id: 'depositPriceExclusion' },
  });

  useEffect(() => {
    if (!itemOptions?.length || !prices) {
      return;
    }

    const excludedIdsArray =
      depositExclusionData?.DepositPriceExclusion?.excludeDepositFromItemPriceCalculation ?? [];

    const excludedIdsMap = excludedIdsArray.reduce<Record<string, true>>((acc, item) => {
      if (item?._id) {
        acc[item._id] = true;
      }
      return acc;
    }, {});

    for (const item of itemOptions) {
      for (const option of item.options ?? []) {
        const optionKey = option?._key?.toString();
        if (optionKey && excludedIdsMap[optionKey]) {
          setDepositValue(prices[optionKey] ?? 0);
          return;
        }
      }
    }
  }, [itemOptions, prices, depositExclusionData]);

  return depositValue;
};
